// extracted by mini-css-extract-plugin
export default {"modalHeader":"FormModalHeader_modalHeader__1pRGR"};